import PropTypes from 'prop-types';
import constants from '../../config/constants';
import DiscountBadge from '../Badges/DiscountBadge/DiscountBadge';
import ServicesPricesStyle from './ServicesPrices.style';

const ServicesPrices = ({ priceList = [], discountBadge }) => {
  const showCmrLogo = priceList.find((price) => price.type === constants.PRICE_TYPE.cmr);

  return (
    <div className="services-prices-section">
      {showCmrLogo && <div className="cmr-icon" />}
      {priceList.map(({ price, type, symbol }, index) => {
        const isFirstPrice = index === 0;
        return (
          <div className="price">
            <div className={`${type}`}>
              {symbol}
              {price[0]}
            </div>
            {isFirstPrice && discountBadge && <DiscountBadge badge={discountBadge} size="copy6" lineHeight="12px" />}
          </div>
        );
      })}
      <style jsx>{ServicesPricesStyle}</style>
    </div>
  );
};

ServicesPrices.defaultProps = {
  discountBadge: null,
};
ServicesPrices.propTypes = {
  priceList: PropTypes.array.isRequired,
  discountBadge: PropTypes.object,
};
export default ServicesPrices;
